import React from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./ViewVirtualAccDetails.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import Button from "../../Subcomponents/Button";
import { useSelector } from "react-redux";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";


const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));

export default function ViewVirtualAccDetails({
  open,
  handleClose,
  data
}) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const classes = useStyles();


  async function sendMailAndSms(email, subject) {
    let message = `<h4>Hi ${data?.leadname},</h4>
    <p>Your virtual account details for VJ Developers is:</p></br>
    <p>Razorpay Customer Id:${data?.razorpaycustomerid}</b></p></br>
    <p>Bank Beneficiary Name:${data?.bankbeneficiaryname}</b></p></br>
    <p>Bank Account Number:${data?.bankaccountnumber}</b></p></br>
    <p>Bank IFSCCode:${data?.bankifsccode}</b></p>`;
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: `+${data?.leadcontactnumber}`,
      message: `Hi ${data?.leadname},Your virtual account details for VJ Developers is:Razorpay Customer Id:  ${data?.razorpaycustomerid},Bank Beneficiary Name:${data?.bankbeneficiaryname},Bank Account Number: ${data?.bankaccountnumber},Bank IFSCCode: ${data?.bankifsccode}`,
      is_international_number:
        data?.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        console("sms resp", resp)
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        return false;
      });
    const emailRes = await sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }

   function shareVirtualAccDetails() {
    presentLoader()
    sendMailAndSms(`${data?.leademail}`, "Virtual Account Details").then(
      (resp) => {
        dismissLoader()
        handleClose()
         
        if (resp.emailRes && resp.sms) {
          successTost("Email and sms sent successfully");
        } else if (resp.emailRes === false && resp.sms) {
          errorTost("Sms sent successfully,error while sending email ");
        } else if (resp.emailRes && resp.sms === false) {
          errorTost("Email sent successfully,error while sending sms ");
        } else {
          errorTost("Error while sending Email and Sms");
        }


      }
    );
  }


  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span
            className={classes.closeIcon}
            onClick={handleClose}
            tabIndex={0}
          >
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Virtual Account Details</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.content}>
            <div
              className={cssClasses.title}
              style={{
                marginTop: "2rem",
                lineHeight: "3rem",
                color: "#667085",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
              }}
            >
<div>Account Number: {data.bankaccountnumber}</div>
<div>IFSC Code: {data.bankifsccode}</div>
<div>Bank beneficiary name: {data.bankbeneficiaryname
}</div>

            </div>
           
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Close"}
              clicked={() => handleClose()}
            />
          </div>
    <div>
    <Button
             style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Share Virtual Account Details"}
              clicked={() => shareVirtualAccDetails()}
            />
    </div>
        </div>
      </Box>
    </Modal>
  );
}
